export default "__VITE_ASSET__BAJFWFVQ__"